import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListDetailsPagination";
import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { getMgbwPaginationOverrides } from "@tSurya/Common/Utilities/mgbwPaginationOverrides";
import { css } from "styled-components";

myListsDetailsOptionsStyles.pagination = getMgbwPaginationOverrides();

myListsDetailsOptionsStyles.paginationGridItem = {
    width: 12,
    css: css`
        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        span[class^="PerPageSelect-"] {
                            justify-content: center;
                        }
                        nav {
                            justify-content: center;
                        }
                        justify-content: center;
                        /* margin: 5px 0 0 !important; */
                    `,
                    css`
                        span[class^="PerPageSelect-"] {
                            justify-content: center;
                        }
                        nav {
                            justify-content: center;
                        }
                        justify-content: center;
                        /* margin: 5px 0 0 !important; */
                    `,
                    css`
                        span[class^="PerPageSelect-"] {
                            justify-content: center;
                        }
                        nav {
                            justify-content: center;
                        }
                        justify-content: flex-end;
                        /* margin: 5px 0 0 !important; */
                    `,
                    css`
                        justify-content: flex-end;
                    `,
                    css`
                        justify-content: flex-end;
                    `,
                ],
                "min",
            )}
    `,
};
